/**
 * Invoice Example Texts
 * Pre-written examples to help users understand the invoice text format
 */

export const invoiceExamples = {
  example1: `SWEETBITES BAKERY INVOICE
Sales: Rina
Customer: Dita Lestari / +62 812-3456-7890
Delivery: Shipped via courier
Date: 2024-01-15
Due: 2024-02-15

Order Details:
Premium Choco Almond Cookies 2 x Rp165,000
Premium Butter Cheese Stick 1 x Rp160,000
Premium Snow Cake 3 x Rp170,000
Regular Pineapple Tart (Nastar) 2 x Rp110,000
Regular Cheese Sago Cookies 1 x Rp105,000

Discount: 10%
Shipping: Rp25,000
Tax: 11%

Notes: Payment due within 30 days. Thank you for your business!
Please transfer to:
Account Name: Clara Wijaya
Bank: BCA
Account Number: 1234567890

Signed by: Clara Wijaya
Role: Owner & Director`,

  example2: `TECH SOLUTIONS SERVICES INVOICE
Invoice #INV-2024-0042
Date: January 15, 2024
From: Tech Solutions Inc.
Email: contact@techsolutions.com
Phone: +1 (555) 123-4567
Address: 123 Tech Plaza, Silicon Valley, CA 94025

Bill To: Acme Corporation
Contact: John Smith
Email: john.smith@acme.com
Phone: +1 (555) 987-6543
Address: 456 Business Ave, New York, NY 10001

Services Rendered:
Web Development Services 40 hours x $85
Server Setup & Configuration 10 hours x $95
Database Migration 5 hours x $100
Technical Support 8 hours x $75

Subtotal: $5,275
Discount: 5% for early payment
Tax: 8.25%
Total: $5,388.44

Payment Terms: Net 15
Notes: Thank you for your business! We appreciate your prompt payment.

Authorized by: Sarah Johnson
Title: Chief Financial Officer`,

  example3: `CONSULTING INVOICE
Invoice Number: 2024-01-156
Date: 15th January 2024
From: Williams & Associates Consulting
Email: info@williamsconsulting.com
Phone: +44 20 7123 4567
Address: 78 Queens Gate, London SW7 5HD, UK

Client: Global Enterprises Ltd
Contact: Michael Chen
Email: m.chen@globalenterprises.com
Phone: +44 161 234 5678
Address: 100 Innovation Park, Manchester M1 5AB

Consulting Services:
Strategic Planning Consultation 3 days x £1,200
Market Research Analysis 2 days x £1,000
Financial Advisory Services 1 day x £1,500
Training & Workshop Delivery 2 days x £800

Expenses:
Travel Expenses: £350
Accommodation: £420

Subtotal: £8,370
VAT (20%): £1,674
Grand Total: £10,044

Payment due by: 15th February 2024
Bank Details:
HSBC UK
Account: Williams & Associates
Sort Code: 40-12-34
Account Number: 12345678

Signed: James Williams
Position: Senior Partner`
};
